import React from 'react';

import { Spoiler, Text } from '@mantine/core';

const Description = ({ text }: { text?: string | null }) => {
    if (!text) {
        return null;
    }

    return (
        <Spoiler maxHeight={176} showLabel="Show more" hideLabel="Show less">
            <Text fz={14} lh="22px" style={{ whiteSpace: 'pre-wrap' }}>
                {text}
            </Text>
        </Spoiler>
    );
};

export { Description };
